import axios from 'axios';

export const signupService = async (dataUser)=>{
  return new Promise((resolve, reject) => {
    axios.post(`${process.env.REACT_APP_URL_API}/auth/register`,dataUser)
      .then(res=>resolve(res))
      .catch(err => reject(err));
  });
}